import CCUpload from './CCUpload'

export default CCUpload
